import IconCard from 'pages/Ui/Cards/IconCard'
import React, { useEffect, useState } from 'react'
import { Button, Card, CardBody, CardText, CardTitle, Col, Container,Modal,ModalBody,ModalHeader,Pagination,PaginationItem,PaginationLink,Popover,PopoverBody,Row, Spinner, UncontrolledPopover } from 'reactstrap'
import { ImFileExcel } from "react-icons/im";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { MdPendingActions } from "react-icons/md";
import { AiOutlineFileSearch } from "react-icons/ai";
import { AiOutlineFileDone } from "react-icons/ai";
import { AiOutlineException } from "react-icons/ai";
import { TiCancel } from "react-icons/ti";
import { Table,Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import SingleOrderForm from './SingleOrderForm';
import useListOrders from './useListOrders';
import useUpdateStatus from './useUpdateStatus';
import useGetDashStatus from './useGetDashStatus';
import { FaAngleUp } from "react-icons/fa";
import { FaAngleDown } from "react-icons/fa";
import { FaEdit } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import ReportCard from './ReportCard';
import { useQueryClient } from '@tanstack/react-query';
import useListComparable from 'pages/comparable/useListComparable';
import { listComparables as listComparablesAPI} from 'services/apiComparable';
import toast from 'react-hot-toast';
import useDownloadReport from './useDownloadReport';
import useInitialData from 'context/useInitialData';
import FinanceReportCard from './FinanceReportCard';
import useDownloadZip from './useDownloadZip';

const QueueManagement = () => {
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    
    // custom hook to get inital data
    const {data:initalData}=useInitialData();
    const products = initalData?.products || [];

    // custom hook to dowload the final generated report
    const{isDownloading,isDownloaded,downloadReport} = useDownloadReport();
    // hook for downloading the final zip for basic proudct
    const{isZipping,isZipped,downloadZip} = useDownloadZip()

    // state for edit modal
    const[isEditModalOpen, setIsEditModalOpen]=useState(false);
    const[currentOrder, setCurrentOrder]=useState(null);
    
    // pagination
    const[currentPage, setCurrentPage]=useState(1);
    const pageSize = 10;

    // for status filter
    const[statusFilter,setStatusFilter]=useState('')
    // for product type filter
    const[productFilter,setProductFilter]=useState('')

    // for search
    const[searchTerm,setSearchTerm]=useState('')
    // get order list
    const{isPending, isSuccess, isError, data, error} = useListOrders(currentPage,pageSize,statusFilter,searchTerm,productFilter);

    useEffect(()=>{
        setCurrentPage(1)
    },[searchTerm,statusFilter,productFilter])
    
    // hoook for getting dash status
    const{isGetting, isGot, isError: isStatusError, error: statusError, data: statusData} = useGetDashStatus();

    // status for dash
    const unassigned = statusData?.unassigned || 0;
    const wip = statusData?.wip || 0;
    const review = statusData?.review || 0;
    const completed = statusData?.completed || 0;
    const exception = statusData?.exception || 0;
    const cancelled = statusData?.cancelled || 0;

    const orders = data?.results || [];
    console.log(orders)
    // const totalCount = data?.count || 0;
    const totalCount = (unassigned + wip + review + completed + exception + cancelled) || 0;
    const totalPages = Math.ceil(totalCount/pageSize)

    // updating status
    const{isUpdating, isUpdated, updateStatus}=useUpdateStatus();
    // checking the status 
    const[isCompleted, setIsCompleted]=useState(false);
    
    // for managing sorting state
    const[sortOrder, setSortOrder] = useState('desc');

    // state for getting the user role
    const[userRole, setUserRole]=useState('');
    useEffect(()=>{
        const user = JSON.parse(localStorage.getItem('userData'))
        if (user){
            const role = user.user.role
            setUserRole(role)
        }
    },[])

    // Style object for the sticky table headers
    const stickyHeaderStyle = {
    position: "sticky",
    top: 0,
    backgroundColor: "white",
    zIndex: 1, // Ensures header is above the scrolling content
    };

    //   handler to open modal and set the current order
    const handleEditClick=(order)=>{
        setCurrentOrder(order);
        setIsEditModalOpen(true);
    }
    //   handler to close the modal,called from on Sucess
    const handleEditSuccess=()=>{
        setIsEditModalOpen(false);
        setCurrentOrder(null);
    };
    // change of status
    const handleStatusChange=(newStatus,orderId)=>{
        if(newStatus ==="Completed"){
            setIsCompleted(stat=> !stat)
        }
        const updatedStatus = {
            "orderId":orderId,
            "newStatus":newStatus
        }
        // console.log(updatedStatus)
        updateStatus(updatedStatus)
    }
    
    // handle review
    const handleReview=(ord)=>{
        const orderIdToReview = ord.order_id;
        const page = 1;
        const size = 10;
        queryClient.invalidateQueries({ queryKey: ['compList', 1, 10, orderIdToReview] }); 
        console.log("triggerred",orderIdToReview)
        navigate('/review-page',{state:{orderId:ord.order_id,file_num:ord.file_num,productType:ord.product_type}})
    }
    // use state for handling the id for downlad button
    const[downloadingOrderId, setDownloadingOrderId] = useState(null);

    const handleDownload=async(orderId)=>{
        console.log("orderid on download report",orderId)
        setDownloadingOrderId(orderId)
        downloadReport(orderId,{
            onSuccess:(data)=>{
                const url = data.final_doc_url;
                console.log("doc_url",url)
                const link = document.createElement('a');
                    link.href = url;
                    // link.setAttribute('download', 'FinalReport.pdf');
                    document.body.appendChild(link);
                    link.click();
                    link.remove();

                    setDownloadingOrderId(null);
            },
            onError: (err) => {
                // alert('Download failed');
                toast.error("Download Failed")
                console.error(err);

                setDownloadingOrderId(null);
            },
        })
        
    }

    const handleDownloadZip = async(orderId,fileNum)=>{
        console.log("downloading the zip file for order",orderId)
        console.log("downloading the zip file for file number",fileNum)
        setDownloadingOrderId(orderId)
        downloadZip(orderId,{
            onSuccess:async(data)=>{
                try{
                    console.log("data after zip download triggering",data)
                    const response = await fetch(data.final_zip_url);
                    const blob = await response.blob();
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');

                    link.href = url;
                    link.download = `${fileNum}.zip`;
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);

                    setDownloadingOrderId(null);
                }
                catch(err){
                    console.error(err);
                    toast.error("Download Failed");
                }
            },
            // onSuccess:(data)=>{
            //     console.log("data after zip download triggering",data)
            //     const url = data.final_zip_url;
            //     const link = document.createElement('a');
            //     link.href = url;
            //     link.setAttribute('download', `${fileNum}.zip`);
            //     document.body.appendChild(link);
            //     link.click();
            //     link.remove();

            //     setDownloadingOrderId(null);
            // },
            onError: (err) => {
                toast.error("Download Failed")
                console.error(err);

                setDownloadingOrderId(null);
            },
        })
    }

  return (
    <Container fluid>
        <Row>
            <Card>
                <Row className='mb-2 border-bottom pb-2 mt-4'>
                    <Col>
                        <h5 className='fw-bold'>Order Summary</h5>
                    </Col>
                </Row>
                <Row>
                    <Row>
                        <Col>
                            <IconCard title="Total Orders" text={totalCount} icon={ImFileExcel}/>
                        </Col>
                        <Col>
                            <IconCard title="Unassigned" text={unassigned} icon={AiOutlineCloseCircle}/>
                        </Col>
                        <Col>
                            <IconCard title="Work In Progress" text={wip} icon={MdPendingActions}/>
                        </Col>
                        <Col>
                            <IconCard title="Review" text={review} icon={AiOutlineFileSearch}/>
                        </Col>
                    </Row>

                    <Row className='mb-0'>
                        <Col>
                            <IconCard title="Completed" text={completed} icon={AiOutlineFileDone}/>
                        </Col>
                        <Col>
                            <IconCard title="Exception" text={exception} icon={AiOutlineException}/>
                        </Col>
                        <Col>
                            <IconCard title="Cancelled" text={cancelled} icon={TiCancel}/>
                        </Col>
                        <Col></Col>
                    </Row>
                </Row>
            </Card>
        </Row>

        <Row>
            <Row className='mb-3 border-bottom pb-2'>
                <Col>
                    <h5 className='fw-bold'>Order Queue</h5>
                </Col>
                <Col>
                    {/* search */}
                    <input
                        type="text" 
                        className="form-control"
                        placeholder="Search by File Number, Client Name"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </Col>
                <Col className='d-flex justify-content-end'>
                    <div className='me-2'>
                        {/* Status filter */}
                        <select
                            className='form-select'
                            value={statusFilter}
                            onChange={(e)=>setStatusFilter(e.target.value)}
                            style={{ width: '200px' }}
                        >
                            <option value="">All Statuses</option>
                            <option value="Unassigned">Unassigned</option>
                            <option value="Work In Progress">Work In Progress</option>
                            <option value="Review">Review</option>
                            <option value="Completed">Completed</option>
                            <option value="Exception">Exception</option>
                            <option value="Cancelled">Cancelled</option>
                        </select>
                    </div>
                    <div>
                        {/* product type filter */}
                        <select
                            className='form-select'
                            value={productFilter}
                            onChange={(e)=>setProductFilter(e.target.value)}
                            style={{ width: '200px' }}
                        >
                            <option value="">All Products</option>
                            {products.map((product,index)=>(
                                <option key={index} value={product.id}>{(product.product_name).toUpperCase()}</option>
                            ))}
                        </select>
                    </div>
                </Col>
            </Row>
            <Row>
                <div className='table-rep-plugin'>
                        <div className="table-responsive mb-0"
                        style={{ maxHeight: "400px",minHeight:"340px", overflowY: "auto" }}
                        >
                            <Table className='table table-striped table-bordered'>
                                <Thead>
                                    <Tr>
                                        <Th style={stickyHeaderStyle}>SL.No</Th>
                                        <Th style={stickyHeaderStyle}>File Number</Th>
                                        {/* <Th style={stickyHeaderStyle}>Order Number</Th> */}
                                        <Th
                                            style={{...stickyHeaderStyle, cursor:'pointer'}}
                                            onClick={()=>setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')}
                                        >
                                            Order Date {sortOrder=== 'asc' ? <FaAngleUp/> : <FaAngleDown/>}
                                        </Th>
                                        <Th style={stickyHeaderStyle}>Client Name</Th>
                                        <Th style={stickyHeaderStyle}>Address</Th>
                                        <Th style={stickyHeaderStyle}>Product Type</Th>
                                        {/* <Th style={stickyHeaderStyle}>APN</Th> */}
                                        <Th style={stickyHeaderStyle}>Status</Th>
                                        <Th style={stickyHeaderStyle}>Actions</Th>
                                    </Tr>
                                </Thead>
                                {isPending && (
                                    <Tbody>
                                        <Tr>
                                            <Td colSpan="18" className="text-center"><Spinner/></Td>
                                        </Tr>
                                    </Tbody>
                                )}

                                {isError && (
                                    <Tbody>
                                        <Tr>
                                            <Td colSpan="18" className="text-center text-danger">
                                                Error fetching data: {error.message}
                                            </Td>
                                        </Tr>
                                    </Tbody>
                                )}
                                {
                                    !isPending && orders.length === 0 &&(
                                        <Tbody>
                                            <Tr>
                                                <Td colSpan="18" className="text-center">
                                                <div className="py-4">
                                                    <div className="d-flex flex-column align-items-center text-muted">
                                                    <i className="bi bi-exclamation-circle fs-1 mb-2"></i>
                                                    <h5 className="mb-1">No Data Found</h5>
                                                    </div>
                                                </div>
                                                </Td>
                                            </Tr>
                                            </Tbody>
                                    )
                                }
                                {
                                    isSuccess && (
                                        <Tbody>
                                    {orders.sort((a,b)=>{
                                        const dateA = new Date(a.created_date);
                                        const dateB = new Date(b.created_date);

                                        return sortOrder === 'asc' ? dateA - dateB : dateB- dateA
                                    }).map((ord,index)=>(
                                        <Tr key={index}>
                                            <Td>{index+1}</Td>
                                            <Td>{ord.file_num}</Td>
                                            {/* <Td>{ord.order_id}</Td> */}
                                            {/* <Td>{ord.created_date.split("T")[0]}</Td> */}
                                            <Td>{(()=>{
                                                    const date = new Date(ord.created_date);
                                                    const mm = String(date.getMonth() + 1).padStart(2,'0');
                                                    const dd = String(date.getDate()).padStart(2,'0');
                                                    const yyyy = date.getFullYear();
                                                    return `${mm}/${dd}/${yyyy}`
                                                })()
                                            }</Td>
                                            <Td>{ord.client_name}</Td>
                                            <Td>
                                                {`${ord.address?.street_number ?? ''} ${ord.address?.street_prefix ?? ''} ${ord.address?.street_name ?? ''} ${ord.address?.street_type ?? ''} ${ord.address?.street_suffix ?? ''} ${ord.address?.unit_number ? 'Unit ' + ord.address.unit_number : ''}, ${ord.address?.city ?? ''}, ${ord.address?.state_name ?? ''} ${ord.address?.zip ?? ''}`}
                                            </Td>
                                            <Td>{ord.product_type.startsWith("DA") ? ord.product_type.replace("DA","Desktop Appraisal") : ord.product_type}</Td>
                                            {/* <Td>{ord.apn}</Td> */}
                                            {/* { userRole === '00000000-0000-0000-0000-000000000003' &&<Td>{ord.status}</Td>}
                                            <Td>
                                                <select
                                                    className={`form-select border-primary-subtle ${ord.status === 'Completed' || ord.status === 'Cancelled'? 'bg-light text-muted' : ''}`}
                                                    value={ord.status}
                                                    onChange={(e)=> handleStatusChange(e.target.value, ord.order_id)}
                                                    disabled={ord.status === "Completed" || ord.status === "Cancelled"}
                                                >
                                                    {ord.status_choices?.map((status, index)=>(
                                                        <option key={index} value={status.value}>{status.label}</option>
                                                    ))}
                                                </select>
                                            </Td> */}
                                           <Td>
                                                {userRole === '00000000-0000-0000-0000-000000000003' ? (
                                                    <span>{ord.status}</span>
                                                ) : (
                                                    <select
                                                    className={`form-select border-primary-subtle ${ord.status === 'Completed' || ord.status === 'Cancelled' ? 'bg-light text-muted' : ''}`}
                                                    value={ord.status}
                                                    onChange={(e) => handleStatusChange(e.target.value, ord.order_id)}
                                                    disabled={ord.status === "Completed" || ord.status === "Cancelled"}
                                                    >
                                                    {ord.status_choices?.map((status, index) => {
                                                        const canCancel = userRole === '00000000-0000-0000-0000-000000000006' || userRole === '00000000-0000-0000-0000-000000000007'
                                                        const isCurrentStatus = ord.status === status.value;
                                                        if(status.value === 'Cancelled' && !canCancel && !isCurrentStatus){return null}

                                                        return(
                                                            <option key={index} value={status.value}>{status.label.toUpperCase()}</option>
                                                        )
                                                    })}
                                                    </select>
                                                )}
                                            </Td>
                                            
                                            <Td>
                                                <div style={{ display: "flex", flexDirection: "row", gap: "0.5rem",alignContent:"space-between",justifyContent:"flex-start" }}>
                                                    <Button  onClick={()=>handleEditClick(ord)}
                                                        style={{ backgroundColor: "#00ADF0", color: "white" }}
                                                        size="sm"
                                                        outline
                                                        disabled={ord.status === 'Completed'}
                                                    >
                                                        Edit
                                                    </Button>

                                                    {userRole !== '00000000-0000-0000-0000-000000000003' && (<Button
                                                        style={{ backgroundColor: "#00ADF0", color: "white" }}
                                                        size="sm"
                                                        outline
                                                        onClick={()=> handleReview(ord)}
                                                        disabled={ord.status !== 'Review' || ord.product_type === "DA-Basic"}
                                                    >
                                                        Review
                                                    </Button>)}

                                                    {ord.status === 'Completed' && <Button
                                                        style={{ backgroundColor: "#00ADF0", color: "white" }}
                                                        size="sm"
                                                        outline
                                                        onClick={()=> ord.product_type === "DA-Basic" ? handleDownloadZip(ord.order_id,ord.file_num) : handleDownload(ord.order_id)}
                                                        disabled={downloadingOrderId === ord.order_id}
                                                    >
                                                        {downloadingOrderId === ord.order_id ? <Spinner size="sm"/> : 'Download'}
                                                    </Button>}
                                                </div>
                                            </Td>
                                        </Tr>
                                    ))}
                                    
                                </Tbody>
                                    )
                                }
                                
                            </Table>
                            
                            <div style={{display:"flex", flexDirection:"row", alignItems:"end", justifyContent:"end"}}>
                                <Pagination size="sm" className="justify-content-center">
                                {/* First Page */}
                                <PaginationItem disabled={currentPage === 1}>
                                    <PaginationLink
                                    first
                                    onClick={() => setCurrentPage(1)}
                                    style={{
                                        backgroundColor: '#f8f9fa',
                                        color: '#007bff',
                                        border: '1px solid #dee2e6',
                                        padding: '5px 10px',
                                        cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
                                    }}
                                    />
                                </PaginationItem>

                                {/* Previous Page */}
                                <PaginationItem disabled={currentPage === 1}>
                                    <PaginationLink
                                    previous
                                    onClick={() => setCurrentPage(prev => prev - 1)}
                                    style={{
                                        backgroundColor: '#f8f9fa',
                                        color: '#007bff',
                                        border: '1px solid #dee2e6',
                                        padding: '5px 10px',
                                        cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
                                    }}
                                    />
                                </PaginationItem>

                                {/* Page Numbers */}
                                {[...Array(totalPages)].map((_, index) => {
                                    const isActive = currentPage === index + 1;
                                    return (
                                    <PaginationItem key={index} active={isActive}>
                                        <PaginationLink
                                        onClick={() => setCurrentPage(index + 1)}
                                        style={{
                                            backgroundColor: isActive ? '#007bff' : '#fff',
                                            color: isActive ? '#fff' : '#007bff',
                                            border: '1px solid #dee2e6',
                                            padding: '5px 12px',
                                            margin: '0 2px',
                                            cursor: 'pointer',
                                            borderRadius: '4px',
                                            fontWeight: isActive ? 'bold' : 'normal',
                                        }}
                                        >
                                        {index + 1}
                                        </PaginationLink>
                                    </PaginationItem>
                                    );
                                })}

                                {/* Next Page */}
                                <PaginationItem disabled={currentPage === totalPages}>
                                    <PaginationLink
                                    next
                                    onClick={() => setCurrentPage(prev => prev + 1)}
                                    style={{
                                        backgroundColor: '#f8f9fa',
                                        color: '#007bff',
                                        border: '1px solid #dee2e6',
                                        padding: '5px 10px',
                                        cursor: currentPage === totalPages ? 'not-allowed' : 'pointer'
                                    }}
                                    />
                                </PaginationItem>

                                {/* Last Page */}
                                <PaginationItem disabled={currentPage === totalPages}>
                                    <PaginationLink
                                    last
                                    onClick={() => setCurrentPage(totalPages)}
                                    style={{
                                        backgroundColor: '#f8f9fa',
                                        color: '#007bff',
                                        border: '1px solid #dee2e6',
                                        padding: '5px 10px',
                                        cursor: currentPage === totalPages ? 'not-allowed' : 'pointer'
                                    }}
                                    />
                                </PaginationItem>
                            </Pagination>
                            </div>
                        </div>
                    </div>
            </Row>

            {(userRole === '00000000-0000-0000-0000-000000000002' || userRole==='00000000-0000-0000-0000-000000000007') && (<Row className="justify-content-center mb-4 mt-4">
                <Col md={4}>
                    <ReportCard />
                </Col>
                <Col md={4}>
                    <FinanceReportCard />
                </Col>
            </Row>)}
        </Row>

         {/* Edit Order Modal */}
            <Modal
                isOpen={isEditModalOpen}
                size="xl"
                backdrop="static"
                keyboard={false}
                toggle={() => setIsEditModalOpen(false)}
                fullscreen="xl"
                fade
                scrollable
            >
                <ModalHeader
                    close={
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => setIsEditModalOpen(false)}
                        />
                    }
                >
                    Edit Order
                </ModalHeader>
                <ModalBody>
                    {/* Render the form only if there is an order to edit */}
                    {currentOrder && (
                        <SingleOrderForm
                            isEditMode={true}
                            orderData={currentOrder}
                            onSuccess={handleEditSuccess}
                        />
                    )}
                </ModalBody>
            </Modal>
    </Container>
  )
}

export default QueueManagement